var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-button analysis-tools",class:{
    active: _vm.tabIsOpened,
    unactive: !_vm.tabIsOpened
  },on:{"click":function($event){return _vm.openTab(_vm.tabClass)}}},[_vm._m(0),_c('OptionsList',{attrs:{"optionsList":_vm.analysisToolsList}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"analysis"},[_vm._v(" Analysis tools "),_c('span',{staticClass:"icon"})])}]

export { render, staticRenderFns }